import React from "react";
import { Button } from "@material-ui/core";
import ResultKoIcon from "../../../resources/wrappers/ResultKo";
import ResultOkIcon from "../../../resources/wrappers/ResultOk";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import "./ResultPageUnauth.scss";
import { HTTPResponses } from "../../../models/HTTPResponses";

const ResultPageUnauth = (props: any) => {
  let icon;
  let title;
  let message;
  let button = null;

  const restart = () => (window.location.href = `${window.location.origin}/changePasswordUnauth#${props.location.state.ott}?utm_source=softpos&utm_medium=email&utm_campaign=${props.location.state.resetType}`);

  switch (props.location.state.resultCase) {
    case HTTPResponses.OK:
      icon = <ResultOkIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />;
      title = "Hai creato la nuova password!";
      message = <>Ti servirà per accedere all’App Nexi POS.</>;
      GoogleTagManagerService.getInstance().pushPageEvent(props.location.pathname + "/success", title, {});
      break;
    case HTTPResponses.USED:
      icon = <ResultKoIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />;
      title = <>Password già reimpostata</>;
      message = (
        <>
          Sembra che tu abbia <b>già reimpostato la tua password</b>.
          <br />
          <br />
          Se ne avessi ancora bisogno, torna sull’App Nexi POS per effettuare una nuova richiesta.
        </>
      );
      break;
    case HTTPResponses.EXPIRED:
      icon = <ResultKoIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />;
      title = "Link reimposta password scaduto";
      message = (
        <>
          Il <b>link</b> che hai ricevuto via email per reimpostare la tua password è <b>scaduto</b>.
          <br />
          <br />
          Se ne avessi ancora bisogno, torna sull’App Nexi POS per effettuare una nuova richiesta.
        </>
      );
      GoogleTagManagerService.getInstance().pushPageEvent(props.location.pathname + "/failure", title, {});
      GoogleTagManagerService.getInstance().pushCustomError('custom_error', 'general', '401', title, undefined, true);
      break;
    //case HTTPResponses.KO:
    //icon = <ResultKoIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />;
    //title = <>Link non valido</>;
    //message = (
    //  <>
    //    Il <b>link</b> che hai ricevuto via email per reimpostare la tua password <b>non è più valido</b>.
    //    <br className={"hide-on-mobile"} />
    //    Torna sull’App Nexi POS per effettuare una nuova richiesta.
    //  </>
    //);
    //break;
    default:
      icon = <ResultKoIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />;
      title = "Si è verificato un errore durante la creazione della nuova password.";
      message = (
        <>
          Ti ricordiamo che la nuova password non può corrispondere
          <br className={"hide-on-mobile"} /> a quella attuale e alle cinque precedentemente utilizzate.
        </>
      );
      button = (
        <Button className={"change-password-unauth-error-button"} onClick={restart}>
          REIMPOSTA PASSWORD
        </Button>
      );
      GoogleTagManagerService.getInstance().pushPageEvent(props.location.pathname + "/failure", title, {});
      GoogleTagManagerService.getInstance().pushCustomError('custom_error', 'general', '400', title, undefined, true);
      break;
  }

  return (
    <div className={"result-page-unauth-main-container"}>
      <div className={"result-page-unauth-main-content"}>
        <div className="result-unauth">
          <>{icon}</>
          <p className={"result-unauth-title-error"}>{title}</p>
          <p className="result-unauth-message">{message}</p>
        </div>
        {button}
      </div>
    </div>
  );
};

export default ResultPageUnauth;
